module.exports = __webpack_public_path__ + "static/media/b.a5cadd68.png";